import { useCallback, useState } from 'react';

import CameraConnection from 'src/models/Camera/CameraConnection';
import { SetLanguageParams } from 'src/models/Camera/Settings/Language/SetLanguage.model';

export function useSetCameraLanguage() {
  const [isSettingLanguage, setIsSettingLanguage] = useState(false);

  const setCameraLanguage = useCallback(async (params: SetLanguageParams) => {
    try {
      setIsSettingLanguage(true);
      await CameraConnection.getInstance().setLanguage(params);
    } finally {
      setIsSettingLanguage(false);
    }
  }, []);

  return { setCameraLanguage, isSettingLanguage };
}
